import { ModalBase, Separators } from 'components';
import { Content } from './components/content/Content';
import ChangesModalHeader from './components/header/ChangesModalHeader';

// import * as S from './CampaignChangesModal.styled';

export const CampaignChangesModal = ({ isOpen$, selectedDate, data }) => {
  return (
    <ModalBase>
      <ChangesModalHeader title='Details For Date' isOpen$={isOpen$} />
      <Separators type={Separators.separatorTypes.small} />
      <Content selectedDate={selectedDate} data={data} />
    </ModalBase>
  );
};
